var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileStoryChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 11,
  viewBox: "0 0 20 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.313.273A1 1 0 0 1 10.586.19l.1.083 9 8.5a1 1 0 0 1-1.276 1.534l-.097-.08L10 2.375l-8.313 7.852a1 1 0 0 1-1.322.045l-.092-.085a1 1 0 0 1-.045-1.322l.085-.092z"
})));
export default SvgFacebookMobileStoryChevronUp;